<template>
  <v-container fluid class="pa-8">
    <v-text-field
      v-model="search"
      label="Buscar usuário..."
      prepend-inner-icon="mdi-magnify"
      outlined
      dark
      class="search-bar mb-6 custom-input"
      @input="userList()"
      clearable
    ></v-text-field>
    <v-simple-table class="custom-table">
      <thead>
        <tr>
          <th></th>
          <th class="text-left">Nome</th>
          <th class="text-left">Nickname</th>
          <th class="text-left">Email</th>
          <th class="text-left">Level</th>
          <th class="text-left">Publicar no Portal Zinnes</th>
          <th class="text-left">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in users"
          :key="user.id"
          :class="{'selected-row': selectedUser.id === user.id}"
          style="height: 70px; font-size: 16px;"
        >
          <td>
            <v-avatar size="50" class="mr-2">
              <v-img v-if="user.profile_photo" :src="user.profile_photo"></v-img>
              <v-icon v-else large>mdi-account-circle</v-icon>
            </v-avatar>
          </td>
          <td>{{ user.name }}</td>
          <td>{{ user.nickname }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.user_level.name }}</td>
          <td>
            <div class="blog-publish-cell">
              <v-switch
                :key="`blog-publish-${user.id}-${user.blogPublishVersion || 0}`"
                :input-value="blogPublishEffective(user)"
                :disabled="isBlogPublishPending(user.id)"
                :loading="isBlogPublishPending(user.id)"
                :aria-label="`Alterar permissão de publicação no Portal Zinnes para ${user.nickname}`"
                color="var(--zinnes-primary)"
                inset
                hide-details
                class="blog-publish-switch"
                @change="toggleBlogPublish(user, $event)"
              ></v-switch>
            </div>
          </td>
          <td>
            <v-btn icon @click="selectUser(user)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="text-center">
          <v-pagination color="var(--zinnes-primary)" 
            v-model="paginate.current_page" 
            :length="paginate.last_page"
            total-visible="5"
            @input="userList"
            ></v-pagination>
    </div>
    <v-dialog v-model="dialog" max-width="800" dark>
      <v-card>
        <v-card-title class="headline">{{ selectedUser.name }}</v-card-title>

        <v-card-text>
          <div>Acessos</div>
          <v-row>
            <v-col cols="6">
              <v-switch
                v-model="selectedUser.commentAccess"
                label="Comentar"
                color="red"
                inset
              ></v-switch>
            </v-col>
            <v-col cols="6">
              <v-switch
                v-model="selectedUser.likeAccess"
                label="Curtir"
                color="red"
                inset
              ></v-switch>
            </v-col>
          </v-row>

          <div class="mt-4">Suspender conta</div>
          <v-row>
            <v-radio-group v-model="selectedUser.suspendDuration">
              <v-col cols="4">
                <v-radio
                  label="1 dia"
                  value="1"
                ></v-radio>
              </v-col>
              <v-col cols="4">
                <v-radio
                  label="7 dias"
                  value="7"
                ></v-radio>
              </v-col>
              <v-col cols="4">
                <v-radio
                  label="Indeterminado"
                  value="indefinite"
                ></v-radio>
              </v-col>
            </v-radio-group>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn  color="red" @click="closeDialog">Cancelar</v-btn>
          <v-btn class="zinnes-primary-btn" @click="banUser">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalUser ref="modal_user" :listar="userList"></ModalUser>

    <v-snackbar v-model="snackbar" color="#31263a" bottom :timeout="5000">
      {{ snackbarMessage }}
      <template #action="{ attrs }">
        <v-btn text color="#f6c945" v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>


<script>
import UserService from '@/server/UserService';
import ModalUser from '@/components/ModalUser.vue';

export default {
  name: "AdmAcessUserView",
  components:{ModalUser},
  data() {
    return {
      search: '',
      dialog: false,
      selectedUser: {},
      service: new UserService(),
      paginate: {},
      pendingBlogPublish: {},
      snackbar: false,
      snackbarMessage: '',
    };
  },
  computed:{
    users: {
            get(){return this.$store.getters['getUsers']},
            set(dado){this.$store.dispatch('setUsers', dado)}
        }
  },
  mounted(){
    this.userList();
  },
  methods: {
    async userList(page=1){
      let params = {
        page,
        search:this.search
      } 
       let response = await this.service.list(params);
       this.users = response.data;
       this.paginate = response;
    },
    selectUser(user) {      
      this.$store.dispatch('setUser',user);
      this.$refs.modal_user.abrirModal();
    },
    closeDialog() {
      this.dialog = false;
      this.selectedUser = {};
    },
    banUser(duration) {
      alert(`Usuário ${this.selectedUser.name} banido por ${duration}`);
      this.closeDialog();
    },
    blogPublishEffective(user) {
      return Boolean(user.blog_publish && user.blog_publish.effective);
    },
    isBlogPublishPending(userId) {
      return Boolean(this.pendingBlogPublish[userId]);
    },
    async toggleBlogPublish(user, granted) {
      if (this.pendingBlogPublish[user.id]) return;

      const snapshot = user.blog_publish ? { ...user.blog_publish } : null;
      this.$set(this.pendingBlogPublish, user.id, true);
      this.applyBlogPublishState(user, granted);

      try {
        const body = await this.service.updateBlogPublishPermission(user.id, granted);
        const state = body && body.blog_publish;
        if (state) {
          this.$set(user, 'blog_publish', state);
          this.$set(user, 'blogPublishVersion', (user.blogPublishVersion || 0) + 1);
        }
        this.notify(granted
          ? `Permissão para publicar no Portal Zinnes liberada para ${user.nickname}.`
          : `Concessão individual de publicação no Portal Zinnes removida para ${user.nickname}.`);
      } catch (error) {
        if (snapshot) {
          this.$set(user, 'blog_publish', snapshot);
        }
        this.notify('Não foi possível alterar a permissão de publicação no Portal Zinnes. Tente novamente.');
      } finally {
        this.$delete(this.pendingBlogPublish, user.id);
      }
    },
    applyBlogPublishState(user, granted) {
      if (!user.blog_publish) {
        this.$set(user, 'blog_publish', {
          effective: granted,
          individual_grant: granted,
          granted_by_level: false,
        });
        return;
      }
      const grantedByLevel = Boolean(user.blog_publish.granted_by_level);
      this.$set(user.blog_publish, 'individual_grant', granted);
      this.$set(user.blog_publish, 'effective', granted || grantedByLevel);
    },
    notify(message) {
      this.snackbarMessage = message;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.search-bar {
  max-width: 500px;
  color: white !important;
}

v-simple-table tbody tr {
  height: 70px;
}

.v-simple-table td {
  font-size: 16px;
  vertical-align: middle;
}

.v-avatar {
  margin-right: 10px;
}

.custom-table{
  background-color: #bbb6b6;
}

.blog-publish-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
}

.blog-publish-switch {
  margin-top: -6px;
  margin-bottom: -6px;
}
</style>

